// extracted by mini-css-extract-plugin
export default {"red":"calculator_red__0jS6U"};